// libs
import * as React from "react";
import { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
// constants
import { ROUTERS } from "../../constants/routers";

const { HOME } = ROUTERS;

const KeycloakLoginPage = () => {
  const { keycloak, initialized } = useKeycloak();

  const location = useLocation();
  const currentLocationState = location.state || {
    from: { pathname: HOME },
  };

  useEffect(() => {
    if (initialized && keycloak && !keycloak.authenticated) {
      keycloak.login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak]);

  if (keycloak && keycloak.authenticated) {
    return <Redirect to={currentLocationState && currentLocationState.from} />;
  }

  return <></>;
};

export default KeycloakLoginPage;
